export const locale = {
  GLOBAL: {
    Title: "پیامک لند",
    PostalCode: "کد پستی",
    postalCodes: "کد های پستی",
    selectedPostalCodes: "کد های پستی انتخاب شده",
    MciNumberCount: "تعداد همراه اول",
    MtuNumberCount: "تعداد ایرانسل",
    TotalCount: "تعداد کل",
    Coefficient: "ضریب",
    Back: "بازگشت",
  },
  ERRORS: {
    PhoneIsNotValid: "شماره تلفن وارد شده صحیح نمیباشد: نمونه 09101234567",
    InvalidNumber: "تعداد وارد شده صحیح نمیباشد",
    NoSelectedLineNumber: "خط ارسالی را انتخاب کنید.",
    EmptyText: "لطفا متن را وارد کنید.",
    UnknownError: "خطای نامشخص",
    TryAgain: "لطفا کمی بعد دباره تلاش کنید.",
    NoAccountCharge: "موجودی ناکافی",
    NoAccess: "دسترسی ندارید.",
    PleasebyeAPlane: "لطفا یک پلن خریداری کنید.",
    PleaseChargeYourAccount: "لطفا اکانت خود را شارژ کنید.",
    AccessDenied: "دسترسی ندارید.",
    AccessDeniedDescription: "برای اطلاعات بیشتر با پشتیبانی تماس بگیرید",
    Error: "خطا",
    InvalidText: "متن نامعتبر",
    InvalidTextContainsLink: "تنها خطوط خدماتی میتوانند حاوی لینک باشند.",
  },
  INFOS: {
    SuccessSentSms: "پیام ارسال شد",
    SmsRequestInQueue: "پیام شما بعد از تایید مدیر ارسال خواهد شد",
    SendData: "اطلاعات ارسال",
    CheckData: "اطلاعات زیر را بخوانید و تایید کنید.",
  },
  TOBE: {
    to: "به ",
    from: "از ",
  },
  FORMS: {
    DestinationPhone: "شماره تلفن گیرنده",
    TestDestinationPhone: "شماره تلفن تست",
    SourceNumber: "شماره فرستده",
    Text: "متن",
    CharCount: "تعداد کاراکترها",
    FarsiCharCount: "تعداد کاراکترهای فارسی",
    EnglishCharCount: "تعداد کاراکتر های انگلیسی",
    Send: "ارسال",
    SendTime: "زمان ارسال",
    SendTest: "ارسال تستی",
    SendToTestNumber: "ارسال به شماره تست",
    SmsCount: "تعداد پیامک",
    SmsLang: "زبان پیامک",
    Add: "اضافه کردن",
    FromFile: "افزودن فایل",
    TestNumber: "شماره تست",
    Test: "تست",
    ServiceRelated: "خدماتی",
    Price: "قیمت",
    NumbersCount: "تعداد شماره ها",
    NumbersCountToSend: "تعدا شماره هایی که به آنها پیام ارسال میشود",
    Search: "جستجو",
    Title: "عنوان",
    RequestTime: "زمان درخواست",
    RequestInformation: "اطلاعات درخواست",
    CreateNewPhoneBook: "ساخت دفترچه تلفن جدید",
  },
  BUTTONS: {
    OK: "باشه",
    AccountCharge: "شارژ حساب",
    Reports: "گزارش ها",
    RemoveAll: "حذف همه",
    BuyAPlane: "خرید پلن",
    Accept: "تایید",
    Reject: "رد کردن",
    Yes: "بله",
    No: "خیر",
    Create: "ایجاد",
    New: "جدید",
    Save: "ذخیره",
    Delete: "حذف",
    More: "بیشتر",
    TryAgain: "تلاش مجدد",
    Close: "بستن",
    RollBack: {
      back: "بازگشت به کاربر قبلی",
      goToMainUser: "بازگشت به کاربر اصلی",
      CurrentUser: "کاربر فعلی",
    },
  },
  DIALOGS: {
    Waiting: "لطفا صبر کنید",
    RejectItQuestion: "رد شود؟",
    AcceptItQuestion: "تایید شود؟",
    Rejected: "رد شد",
    Accepted: "تایید شد",
    Error: "خطا",
  },
  CONFIRM: {
    Delete: "آیا از حذف مطمعین هستید؟",
    DeleteA: "ایا مطمعین از حذف {a} هستید",
    DeleteALL: "آیا از حذف همه مطمعین هستید؟",
  },
  LANGUAGE: {
    English: "انگلیسی",
    Persian: "فارسی",
  },
  language: {
    selectAll: "انتخاب همه",
    lang: {
      fa: "فارسی",
      ar: "عربی",
      ar_ae: "عربی (امارات)",
      ar_iq: "عربی (عراق)",
      en_US: "انگلیسی (آمریکا)",
      en_GB: "انگلیسی (بریتانیا)",
      de: "آلمانی",
      fr: "فرانسوی",
      zh_CN: "چینی ساده",
      zh_TW: "چینی سنتی",
      tr: "ترکی",
      ru: "روسی",
      hy: "ارمنی",
    },
    only_manual_now: "در حال حاضر فقط ترجمه دستی امکان‌پذیر است",
    ai_coming_soon: "ترجمه هوش مصنوعی به زودی فعال می‌شود",
    got_it: "متوجه شدم",
    origin_language: "زبان اصلی",
    target_languages: "سایر زبان‌ها",
    remove_all: "حذف همه زبان‌ها",
    translation_method: "روش ترجمه را انتخاب کنید",
    manual_translation: "ترجمه دستی",
    ai_translation: "ترجمه هوش مصنوعی",
    coming_soon: "به زودی",
    source_language_updated: "زبان اصلی بروزرسانی شد",
    error_changing_source_language: "خطا در تغییر زبان اصلی",
    source_language_created: "زبان اصلی جدید ایجاد شد",
    languages_saved: "زبان‌های جدید ذخیره شد",
    error_saving_languages: "خطا در ذخیره زبان‌ها",
    error_loading_language: "خطا در بارگذاری زبان",
    languages_removed: "زبان‌های حذف‌شده",
    new_languages_to_save: "زبان‌های جدید برای ذخیره",
    saved: "ذخیره شد",
    management_langs: "مدیریت زبان",
    add_langs: "افزودن زبان",
    change_language: "تغییر زبان",
    visit_card: "کارت ویزیت",
    translate_to: "ترجمه شود به",
    main_language: "زبان",
    no_languages_available: "زبانی در دسترس نیست",
    return_to_default: "بازگشت به زبان اصلی",
    translate: "ترجمه",
    changes_pending: "در انتظار اعمال تغییرات",
    apply_changes: "اعمال تغییرات",
    cancel_changes: "لغو",
  },
  LISTS: {
    NoData: "داده ای وجود ندارد",
    NoDataFound: "داده ای پیدا نشد",
    NoDataFoundFor: "داده ای برای {a} پیدا نشد",
    NoPhoneNumber: "شماره ای پیدا نشد",
    NoPostalCode: "کد پستی ای پیدا نشد",
    AddANumber: "شماره ای اضافه کنید",
    City: "شهر",
    AddedBefore: "قبلا اضافه شده است",
  },
  PAGES: {
    SendSms: "ارسال پیامک",
    MapSms: "ارسال با نقشه",
    PhoneBook: "دفترچه تلفن",
  },
  MONETARY: {
    Rial: "ریال",
  },
  HINTS: {
    SendMessageTitle:
      "عنوان نام دلخواهی است که میتوانید از عنوان پیام های قبلی ارسال شده استفاده کنید تا متن پیام در بخش متن نوشته شود. عنوان در پیام ارسال نمیشود. عنوان برای بخش گذارش گیری و پیشنهادات پیام استفاده میشود.",
    SendMessageTime:
      "زمان ارسال زمانی است که پیامک شما در صف ارسال قرار گرفته میشود. ت.جه داشته باشید که در صورت تایید نشدن توسط ادمین پیامک ارسال نمیشود.",
    CreatePhoneBook:
      "هنگام ارسال پیامک برای اضافه کردن شماره ازا این نام استفاده میشود.",
  },
  TOASTS: {
    SuccessCreate: "با موقیت ایجاد شد",
    FailedCreated: "خطا در ایجاد کردن",
    SuccessDelete: "حذف شد",
    FailedDelete: "خطا در حذف",
    SuccessEdit: "ویرایش شد",
    FailedEdit: "خطا در ویرایش",
    AddedSuccess: "اضافه شد",
    AddedFailed: "خطا در اضافه کردن",
  },
  WALLET: {
    CustomCharge: "مبلغ دلخواه",
    GateWay: "درگاه پرداخت",
    Price: "مبلغ",
    Details: [
      "٩٪؜ ماليات به مبلغ وارد شده اضافه خواهد شد.",
      "لطفا در درج مبلغ دقت لازم را مبذول فرمایید، مبلغ واریزی به هیچ عنوان قابل استرداد نمی باشد.",
    ],
    noGateWay: "درگاهی برای شما تعریف نشده است.",
    PriceNotInRange: "مبلغ ورودی باید بین {min} ریال و {max} ریال باشد.",
    Pay: "پرداخت",
    ErrorOnRedirectToGateWay: "خطا در انتقال به درگاه پرداخت",
    ChargeWalletButtonDescription: "بازدن روی دکمه + حساب خود را شارژ کنید",
  },
  login: {
    phoneField: {
      placeholderIran: "با ۹ شروع کنید (مثال: +98 912 345 6789)",
      placeholderDefault: "شماره تلفن خود را وارد کنید",
      maxDigitsError: "حداکثر {count} رقم مجاز است!",
      iranMustStartWith9: "شماره موبایل باید با ۹ شروع شود (مثل ۹۱۲...)",
    },
    signup_button: "ثبت نام می کنم!",
    forget_password_title: "فراموشی رمز عبور",
    register_title: "ثبت نام رایگان",
    login_title: "ورود",
    back: "بازگشت",
    username_label: "شماره موبایل/نام کاربری",
    otp_resend_button: "ارسال مجدد کد",
    password_label: "رمز عبور",
    password_hint: "حداقل 8 کاراکتر",
    name_label: "نام",
    name_rule: "حداقل ۳ کاراکتر",
    lastname_label: "نام خانوادگی",
    phone_label: "تلفن همراه",
    nid_label: "کد ملی",
    parent_phone_label: "تلفن همراه معرف(اختیاری)",
    terms_and_conditions_message:
      "ثبت نام به منزله قبول قوانین و مقررات ترمینال تبلیغات می باشد.",
    terms_and_conditions_link: "قوانین و مقررات",
    close: "بستن",
    forgot_password_link: "آیا پسوورد خود را فراموش کرده اید؟",
    change_password: "تغییر رمز",
    register_button: "ثبت نام",
    login_button: "ورود",
    login_with_google: "ورود با گوگل",
    login_with_sms: "ورود با پیامک",
    login_with_password: "ورود با رمز",
    already_registered: "قبلا ثبت نام کرده اید؟",
    login_here: "ورود",
    no_account: "حسابی ندارید؟",
    signup_now: "هم اکنون ثبت نام کنید!",
    more_info: "اطلاعات بیشتر",
    text_login: "ورود",
    text_register: "ثبت نام",
    required_field: "فیلد اجباری می باشد.",
    min_8_char: "فیلد شما کوچک تر از 8 کاراکتر است",
    required: "این فیلد ضروری است",
    min_3_char: "حداقل ۳ کاراکتر",
    max_50_char: "حداکثر ۵۰ کاراکتر",
    no_internet: "شما به اینترنت متصل نیستید",
    no_phone_entered: "شما شماره ای را وارد نکرده اید",
    otp_sent_successfully: "کد تایید با موفقیت برای شما ارسال شد.",
    please_register_first: "لطفا ابتدا ثبت نام کنید!",
    wait_3_min: "لطفا به مدت سه دقیقه صبر کنید و دوباره درخواست بدهید.",
    login_successful: "با موفقیت وارد شدید",
    internet_connection_error: "مشکل در اتصال به اینترنت!",
    agree_to_terms_error: "شما با قوانین و مقررات موافقت نکردید!",
    otp_sent_successfully_register: "کد تایید با موفقیت فرستاده شد.",
    error: "خطا",
    registration_nid_required_notice:
      "به منظور ارائه خدمات با امنیت بالا و پیشگیری از هرگونه کلاهبرداری (فیشینگ) و سوء استفاده از سامانه، درج کد ملی در ترمینال تبلیغات برای ثبت‌نام الزامی است.",
  },
  home: {
    title: "خانه",
    selectSystem: "انتخاب سامانه",
    yourPoints: "امتیاز های شما",
    discountCodes: "کد های تخفیف",
    all: "همه",
    discounts: "تخفیف ها",
    systemGuide: "راهنمای سامانه",
    yourPointsDynamic: "امتیاز شما: {points}",
    confirm: "تایید",
    copy: "کپی",
  },
  badges: {
    free: "رایگان",
    preRegister: "پیش ثبت نام",
    comingSoon: "به زودی",
    testVersion: "نسخه آزمایشی",
  },
  services: {
    qrLand: {
      title: "سامانه کیوآر لند",
      description: "ساخت QR داینامیک",
      property: {
        0: "بررسی و انتخاب نوع و مکان تبلیغات",
        1: "بررسی و انتخاب انواع تبلیغات در سینما",
        2: "عدم نیاز به پرداخت پورسانت و هزینه اضافی",
        3: "مدیریت یکپارچه کلیه تبلیغات درج شده در سینماها",
      },
    },
    payamak: {
      title: "سامانه پیامک لند",
      description: "ارسال پیامک انبوه تبلیغاتی",
      property: {
        0: "ارسال پیامک انبوه",
        1: "دارای بانک شماره به روز",
        2: "ارسال پیامک به باشگاه مشتریان",
        3: "قابلیت اتصال به کلیه سایت‌ها و نرم‌افزارها",
      },
    },
    robot: {
      title: "سامانه ربات لند",
      description: "مدیریت همزمان کلیه شماره‌ها، آگهی‌ها و پنل‌ها",
      property: {
        0: "ثبت آگهی گروهی و انبوه",
        1: "مدیریت زماندار، تدریجی و هوشمند آگهی‌ها",
        2: "اجاره و افزودن شماره نامحدود جهت ثبت آگهی",
        3: "ثبت و مدیریت کلیه آگهی‌ها به صورت همزمان",
      },
    },
    infoLand: {
      title: "اینفو لند",
      description: "بیش از 2500 بانک اطلاعاتی به روز مشاغل",
      property: {
        0: "دارای کلیه اطلاعات صنفی",
        1: "دسته‌بندی کلیه شهرها و استان‌ها",
        2: "بانک اطلاعات کلیه اصناف کشور",
        3: "قابلیت بررسی نمونه کلیه بانک‌ها",
      },
    },
    graphic: {
      title: "سامانه گرافیک لند",
      description: "0 تا 100 طراحی گرافیکی و ویدئو",
      property: {
        0: "طراحی لوگو و ست اداری",
        1: "کلیه خدمات چاپ و بسته‌بندی",
        2: "طراحی کاتالوگ، بروشور و جعبه",
        3: "طراحی و چاپ انواع بنر در سایزهای مختلف",
      },
    },
    bestWebLand: {
      title: "سامانه بست وب لند",
      description: "طراحی، پشتیبانی و سئو سایت",
      property: {
        0: "سئو محتوا",
        1: "سئو خارجی (off-page)",
        2: "سئو تکنیکال (technical)",
        3: "سئو داخلی (on-page)",
      },
    },
    onlineShop: {
      title: "سامانه سایت ساز آنلاین",
      description: "فقط چند کلیک فاصله با دنیای دیجیتال",
      badge: "مشارکت در فروش",
      property: {
        0: "سئو محتوا",
        1: "سئو خارجی (off-page)",
        2: "سئو تکنیکال (technical)",
        3: "سئو داخلی (on-page)",
      },
    },
    social: {
      title: "تبلیغات در شبکه‌های اجتماعی",
      description: "بررسی و انتخاب بهترین‌های پیج، کانال",
      property: {
        0: "بررسی کلیه پیج‌های پربازدید",
        1: "مدیریت یکپارچه کلیه تبلیغات تحت پوشش",
        2: "عدم نیاز به پرداخت پورسانت و هزینه اضافی",
        3: "ثبت سفارش آنلاین تبلیغات در پیج‌های پسندیده",
      },
    },
    billboard: {
      title: "اجاره بیلبورد آنلاین",
      description: "بدون واسطه با بررسی هدفمند بیلبورد",
      property: {
        0: "بررسی مکان و نوع بیلبورد",
        1: "مدیریت کلیه بیلبوردهای تحت پوشش",
        2: "ارتباط مستقیم و بدون واسطه با مالک بیلبورد",
        3: "عدم نیاز به پرداخت پورسانت و هزینه اضافی",
      },
    },
    internationalMedia: {
      title: "تبلیغات در رسانه‌های ملی",
      description: "بررسی و درج تبلیغات در تلویزیون و رادیو",
      property: {
        0: "بررسی و انتخاب زمان انتشار تبلیغات",
        1: "بررسی و انتخاب انواع تبلیغات تلویزیونی",
        2: "بررسی و انتخاب انواع تبلیغات رادیویی",
        3: "بررسی و انتخاب تبلیغ در نوع برنامه تلویزیونی",
      },
    },
    transport: {
      title: "تبلیغات در ناوگان حمل و نقل",
      description: "فرودگاه، ایستگاه‌های قطار، اتوبوس و مترو",
      property: {
        0: "بررسی و انتخاب نوع و مکان تبلیغات",
        1: "بررسی و انتخاب انواع تبلیغات در مترو",
        2: "عدم نیاز به پرداخت پورسانت و هزینه اضافی",
        3: "مدیریت یکپارچه کلیه تبلیغات درج شده در مترو",
      },
    },
    cinema: {
      title: "تبلیغات در رسانه‌های تصویری",
      description: "درج تبلیغات در سینما، سایت‌های اشتراک ویدئو",
      property: {
        0: "بررسی و انتخاب نوع و مکان تبلیغات",
        1: "بررسی و انتخاب انواع تبلیغات در سینما",
        2: "عدم نیاز به پرداخت پورسانت و هزینه اضافی",
        3: "مدیریت یکپارچه کلیه تبلیغات درج شده در سینماها",
      },
    },
    estate: {
      title: "سامانه آنلاین املاک",
      description: "مدیریت فایل‌ها، مشاورین و مشتریان",
      property: {
        0: "بررسی و انتخاب نوع و مکان تبلیغات",
        1: "بررسی و انتخاب انواع تبلیغات در سینما",
        2: "عدم نیاز به پرداخت پورسانت و هزینه اضافی",
        3: "مدیریت یکپارچه کلیه تبلیغات درج شده در سینماها",
      },
    },
    AIGeneration: {
      title: "سامانه هوش مصنوعی",
      description: "ساخت تصویر، چت‌بات",
    },
    ShortLink: {
      title: "سامانه لینک کوتاه",
      description: "ساخت لینک کوتاه",
    },
    customer: {
      title: "سامانه مدیریت آنلاین مشتریان",
      description: "مدیریت، پشتیبانی و ایجاد مشتریان وفادار",
      property: {
        0: "بررسی و انتخاب نوع و مکان تبلیغات",
        1: "بررسی و انتخاب انواع تبلیغات در سینما",
        2: "عدم نیاز به پرداخت پورسانت و هزینه اضافی",
        3: "مدیریت یکپارچه کلیه تبلیغات درج شده در سینماها",
      },
    },
    internetBroadcasting: {
      title: "درج و مدیریت تبلیغات اینترنتی",
      description: "تبلیغات گوگل ادز، تبلیغات کلیکی، رپورتاژ",
      property: {
        0: "بررسی و انتخاب نوع و مکان تبلیغات",
        1: "بررسی و انتخاب انواع تبلیغات در سینما",
        2: "عدم نیاز به پرداخت پورسانت و هزینه اضافی",
        3: "مدیریت یکپارچه کلیه تبلیغات درج شده در سینماها",
      },
    },
    emailMarketing: {
      title: "سامانه ایمیل مارکتینگ",
      description: "ارسال ایمیل تبلیغاتی به کلیه مشاغل کشور",
      property: {
        0: "بررسی و انتخاب نوع و مکان تبلیغات",
        1: "بررسی و انتخاب انواع تبلیغات در سینما",
        2: "عدم نیاز به پرداخت پورسانت و هزینه اضافی",
        3: "مدیریت یکپارچه کلیه تبلیغات درج شده در سینماها",
      },
    },
    adsOnStudium: {
      title: "تبلیغات در ورزشگاه و نمایشگاه‌ها",
      description: "حضور برندتان در بزرگ‌ترین مراکز",
      property: {
        0: "بررسی و انتخاب نوع و مکان تبلیغات",
        1: "بررسی و انتخاب انواع تبلیغات در سینما",
        2: "عدم نیاز به پرداخت پورسانت و هزینه اضافی",
        3: "مدیریت یکپارچه کلیه تبلیغات درج شده در سینماها",
      },
    },
    bidOnline: {
      title: "سامانه جامع مزایده آنلاین",
      description: "آنلاین مزایده بگذارید، در مزایده شرکت کنید",
      property: {
        0: "بررسی و انتخاب نوع و مکان تبلیغات",
        1: "بررسی و انتخاب انواع تبلیغات در سینما",
        2: "عدم نیاز به پرداخت پورسانت و هزینه اضافی",
        3: "مدیریت یکپارچه کلیه تبلیغات درج شده در سینماها",
      },
    },
    onlineTools: {
      title: "سامانه ابزارهای آنلاین کسب و کار",
      description: "کلیه ابزارهای کمکی هر نوع کسب و کار",
      property: {
        0: "بررسی و انتخاب نوع و مکان تبلیغات",
        1: "بررسی و انتخاب انواع تبلیغات در سینما",
        2: "عدم نیاز به پرداخت پورسانت و هزینه اضافی",
        3: "مدیریت یکپارچه کلیه تبلیغات درج شده در سینماها",
      },
    },
    onlineLearn: {
      title: "سامانه آموزش آنلاین مشاغل",
      description: "بررسی و انتخاب هدفمند آموزش‌ها",
      property: {
        0: "بررسی و انتخاب نوع و مکان تبلیغات",
        1: "بررسی و انتخاب انواع تبلیغات در سینما",
        2: "عدم نیاز به پرداخت پورسانت و هزینه اضافی",
        3: "مدیریت یکپارچه کلیه تبلیغات درج شده در سینماها",
      },
    },
    cloud: {
      title: "هاستینگ و خرید دامنه",
      description: "خرید هاست، دامنه و سرور",
      property: {
        0: "بررسی و انتخاب نوع و مکان تبلیغات",
        1: "بررسی و انتخاب انواع تبلیغات در سینما",
        2: "عدم نیاز به پرداخت پورسانت و هزینه اضافی",
        3: "مدیریت یکپارچه کلیه تبلیغات درج شده در سینماها",
      },
    },
    QrlandShop: {
  title: "مدیریت فروشگاه‌های آنلاین",
  description: "مدیریت یکپارچه محصولات، مارکت‌پلیس‌ها و قیمت‌گذاری هوشمند",
  property: {
    0: "مانیتورینگ و مدیریت جامع محصولات",
    1: "مدیریت تنوع‌های محصول",
    2: "مانیتورینگ و مدیریت مارکت‌پلیس",
    3: "استراتژی‌های قیمت‌گذاری هوشمند",
  },
},
  },
  "planning.title": "برنامه ریزی",
  "tabs.reminder": "یادآوری",
  "tabs.notes": "یاداشت ها",
  "tabs.calendar": "تقویم",
  "notes.creationDate": "تاریخ ایجاد",
  "common.save": "ثبت",
  "common.cancel": "انصراف",
  "actions.quickActions": "اقدامات سریع",
  "notes.writeMessage": "نوشتن پیام",
  "notes.titlePlaceholder": "عنوان یادداشت",
  "notes.addNote": "افزودن یادداشت",
  "notes.updatedSuccess": "یادداشت با موفقیت بروزرسانی شد.",
  "notes.addedSuccess": "یادداشت با موفقیت اضافه شد.",
  "common.deletedSuccess": "با موفقیت حذف شد",
  "common.confirmDelete": "آیا از حذف مطمئن هستید؟",
  "news.title": "اخبار سایت",
  "news.noNews": "هیچ خبری روی سایت ثبت نشده است.",
  "news.view": "مشاهده",
  "remember.add": "ایجاد یادآوری",
  "remember.update": "بروزرسانی یادآوری",
  "remember.titleLabel": "عنوان",
  "remember.dateLabel": "تاریخ یادآوری",
  "remember.confirmDelete": "آیا از حذف مطمئن هستید؟",
  "remember.deleteSuccess": "یادآوری با موفقیت حذف شد.",
  "remember.createSuccess": "یادآوری جدید ایجاد شد.",
  "remember.updateSuccess": "یادآوری بروزرسانی شد.",
  "points.receivedAwards": "جایزه‌های دریافتی",
  "points.pointsHistory": "تاریخچه امتیازها",
  "points.points": "امتیاز",
  "points.discountTitle": "تخفیف ربات لند",
  "points.discountText": "به ازای هر ۵۰۰ امتیاز",
  events: {
    title: "رویدادها",
    addEvent: "افزودن رویداد",
    calendar: "تقویم پایه",
    close: "بستن",
    save: "ذخیره",
    update: "بروزرسانی",
    confirmDelete: "آیا از حذف مطمئن هستید؟",
    successAdd: "با موفقیت اضافه شد.",
    successDelete: "رویداد با موفقیت حذف شد.",
    successUpdate: "بروزرسانی موفقیت‌آمیز بود.",
    titleLabel: "عنوان",
    descriptionLabel: "توضیحات",
    colorLabel: "رنگ",
    removeAfterDrop: "بعد از رها کردن",
    createEvent: "ایجاد رویداد",
  },
  copySuccess: "با موفقیت کپی شد.",
  copyTextTitle: "کپی کردن",
  copiedTextTitle: "کپی شد",
  copySuccess: "با موفقیت کپی شد.", // For CopyButton.vue
  ribbon: {
    new: "جدید",
  },
  coupons: [
    {
      text: "این کوپن 3 هفته اعتبار دارد",
      title: "متن غیر تکراری 20%",
    },
    {
      text: "این کوپن 2 هفته اعتبار دارد",
      title: "طراحی سایت 5%",
    },
    {
      text: "این کوپن فقط یکبار قابلیت استفاده دارد",
      title: "مدیریت پیج 10%",
    },
    {
      text: "این کوپن به صورت دائمی برای شما فعال شده است",
      title: "طراحی گرافیکی 5%",
    },
    {
      text: "این کوپن فقط یکبار قابل استفاده است",
      title: "چاپ 2%",
    },
  ],
  userLinks: {
    profile: {
      title: "نمای کلی",
      invitation: { title: "دعوت از دوستان" },
      info: { title: "اطلاعات شخصی" },
      edit: { title: "تکمیل پروفایل" },
      changePass: { title: "تغییر گذرواژه" },
    },
  },
  profileLinks: {
    orders: "سفارشات",
    addresses: "آدرس ها",
  },
  customPage: {
    overview: "نمای کلی",
    personalInfo: "اطلاعات شخصی",
    changePassword: "تغییر گذرواژه",
    completeProfile: "تکمیل پروفایل",
    email: "ایمیل",
    balance: "اعتبار",
    phone: "شماره تلفن",
    rial: "ریال",
  },
  widget12: {
    inviteFriends: "دعوت از دوستان",
    viewInvitedUsers: "مشاهده لیست کاربران معرفی شده توسط شما",
    yourInviteCode: "کد دعوت شما",
    createNewUser: "ایجاد کاربر جدید",
    copyText: "کپی کردن",
    userCreatedSuccess: "کاربر جدید با موفقیت ایجاد شد",
    notCreated: "ساخته نشده",
  },
  userInfo: {
    userInformation: "اطلاعات کاربری",
    profilePicture: "تصویر پروفایل",
    allowedFileTypes: "انواع فایل های مجاز: png، jpg، jpeg.",
    profilePictureSize:
      "عکس پروفایل باید در اندازه های (مثال: ۴۸۰ × ۴۸۰) یکسان باشد.",
    firstName: "نام",
    lastName: "نام خانوادگی",
    username: "نام کاربری",
    phone: "شماره تماس",
    email: "ایمیل",
    receiveSMS: "دریافت پیامک",
    smsCostNote:
      "با فعال کردن این گزینه هزینه ارسال پیامک ها از حساب شما کسر خواهد شد.",
    saveChanges: "ثبت تغییرات",
    profileUpdated: "پروفایل شما با موفقیت بروزرسانی شد.",
  },
  emailSettings: {
    completeProfile: "تکمیل پروفایل",
    completeProfileDesc: "تکمیل اطلاعات شخص یا سازمان",
    cancel: "انصراف",
    update: "به روز رسانی",
    save: "ذخیره",
    selectPersonType: "نوع شخص را انتخاب نمایید؟",
    realPerson: "شخص حقیقی",
    legalPerson: "شخص حقوقی",
    phone: "شماره همراه",
    landline: "شماره ثابت",
    fatherName: "نام پدر",
    nationalCode: "کد ملی",
    idNumber: "شماره شناسنامه",
    birthday: "تاریخ تولد",
    placeOfBirth: "محل تولد",
    postalCode: "کد پستی",
    email: "ایمیل",
    introduction: "نحوه آشنایی",
    nationalCodePic: "عکس کارت ملی",
    plaque: "پلاک",
    address: "آدرس کامل",
    companyName: "نام شرکت/فروشگاه",
    registrationNumber: "شماره ثبت",
    economicCode: "کد اقتصادی",
    organizationIdentity: "شناسنامه ملی سازمانی",
    companyType: "نوع شرکت",
    activity: "حوزه فعالیت",
    registrationAd: "تصویر آگهی ثبت شرکت",
    lastPublishedAd: "تصویر آخرین آگهی رسمی منتشر شده",
    statute: "تصویر اساسنامه شرکت",
    agentLetterPic: "تصویر نامه معرفی نماینده شرکت",
    successMessage: "با موفقیت ثبت شد",
    errorSelectType: "لطفا یک مورد را انتخاب کنید.",
    rules: {
      companyName: "فیلد نام شرکت یا فروشگاه اجباری می باشد.",
      registrationNumber: "فیلد شماره ثبت اجباری می باشد.",
      economicCode: "فیلد کد اقتصادی اجباری می باشد.",
      organizationIdentity: "فیلد شناسنامه ملی سازمانی اجباری می باشد.",
      registrationAd: "فیلد تصویر آگهی ثبت شده اجباری می باشد.",
      lastPublishedAd: "فیلد تصویر آخرین آگهی رسمی منتشر شده اجباری می باشد.",
      telephone: "فیلد شماره ثابت اجباری می باشد.",
      fatherName: "فیلد نام پدر اجباری می باشد.",
      nationalCode: "فیلد کد ملی اجباری می باشد.",
      birthday: "فیلد تاریخ تولد اجباری می باشد.",
      idNumber: "فیلد شماره شناسنامه اجباری می باشد.",
      placeOfBirth: "فیلد محل تولد اجباری می باشد.",
      postalCode: "فیلد کد پستی اجباری می باشد.",
      nationalCodePic: "فیلد عکس کارت ملی اجباری می باشد.",
      address: "فیلد آدرس اجباری می باشد.",
      plaque: "فیلد پلاک اجباری می باشد.",
    },
    companyTypes: {
      governmental: "دولتی",
      private: "خصوصی",
      commonStock: "سهامی عام",
      specialStock: "سهامی خاص",
    },
  },
  changePassword: {
    title: "تغییر گذرواژه",
    description: "گذرواژه حساب خود را تغییر دهید",
    cancel: "لغو",
    update: "بروزرسانی",
    passwordInstructions: {
      forgotPassword:
        "اگر تا به امروز شما گذرواژه وارد نکرده باشید می‌توانید روی گزینه فراموشی رمزعبور کلیک کنید.",
      passwordRequirements:
        "گذرواژه حتما باید ۸ کاراکتر باشد که شامل اعداد، حروف بزرگ و کوچک انگلیسی و شامل نمادها است.",
      passwordPrivacy: "لطفا گذرواژه خود را در اختیار دیگران قرار ندهید.",
      keyboardLanguage:
        "هنگام تعریف گذرواژه از انگلیسی بودن کیبورد خود مطمئن شوید.",
    },
    currentPassword: "گذرواژه قبلی",
    newPassword: "گذرواژه جدید",
    confirmNewPassword: "تکرار گذرواژه جدید",
    addOrForgotPassword: "افرودن یا فراموشی رمز",
    changePasswordWithCode: "تغییر گذرواژه با شماره",
    close: "بستن",
    change: "تغییر",
    enterCode: "کد را وارد کنید",
    successMessage: "گذرواژه با موفقیت به‌روزرسانی شد",
    invalidCode: "کد مورد نظر صحیح نمی‌باشد.",
    tooManyAttempts: "تلاش بیش از حد مجاز!",
    rules: {
      required: "فیلد اجباری می‌باشد.",
      min: "فیلد شما کوچک‌تر از ۸ کاراکتر است",
      equal: "فیلد رمز عبور با فیلد تکرار گذرواژه جدید یکسان نیست",
      number: "تعداد ارقام شماره را وارد کنید",
    },
  },
  router: {
    dashboard: "داشبورد",
    contacts: "باشگاه مشتریان",
    editContact: "ویرایش مشتری",
    createContact: "ایجاد مشتری",
    customers: "لیست مشتریان",
    contactList: "تماس یار",
    messages: "پیام‌ها",
    messageCategories: "دسته‌بندی پیام‌ها",
    oldTransactions: "تراکنش‌های قدیمی",
    yourTransactions: "تراکنش‌های شما",
    buyPanel: "خرید پنل",
    permissions: "دسترسی‌ها",
    createPermission: "ایجاد پرمیشن",
    invitations: "لیست دعوتی‌های من",
    editUser: "ویرایش کاربر",
    userInformation: "مشاهده اطلاعات کاربر",
    walletEdit: "ویرایش اطلاعات کیف پول کاربر",
    userHistory: "تاریخچه کاربر",
    userNotificationsHistory: "تاریخچه اعلانات کاربران",
    notifications: "اعلانات",
    createNotification: "ایجاد اعلان",
    editNotification: "ویرایش اعلان",
    adminNotifications: "اعلانات ادمین",
    yourNotifications: "اعلانات شما",
    adminNotificationsList: "اعلانات مدیر",
    tickets: "تیکت‌ها",
    createTicket: "ثبت تیکت جدید",
    editTicket: "ویرایش تیکت",
    departments: "دپارتمان‌ها",
    createDepartment: "دپارتمان جدید",
    editDepartment: "ویرایش دپارتمان",
    adminTickets: "مدیریت تیکت‌ها",
    discounts: "تخفیف‌ها",
    createDiscount: "ایجاد تخفیف",
    editDiscount: "ویرایش تخفیف",
    workReports: "گزارش کار",
    createWorkReport: "ایجاد گزارش کار",
    callMonitoring: "مانیتورینگ تماس",
    adminWorkReports: "مدیریت گزارش کار",
    editWorkReport: "نمایش و ویرایش گزارش کار",
    packProperties: "ویژگی‌های بسته",
    createPackProperty: "ایجاد ویژگی بسته",
    editPackProperty: "ویرایش ویژگی بسته",
    panels: "پنل‌ها",
    createPanel: "ایجاد پنل",
    editPanel: "ویرایش پنل",
    transferRequests: "درخواست‌های برداشت",
    editTransferRequest: "ویرایش درخواست برداشت",
    tariffs: "تعرفه‌ها",
    createTariff: "ایجاد تعرفه",
    editTariff: "ویرایش تعرفه",
    requests: "درخواست‌ها",
    viewUser: "مشاهده کاربر",
    manageTransactions: "مدیریت تراکنش‌ها",
    viewTransaction: "مشاهده تراکنش",
    manageConfigs: "مدیریت تنظیمات",
    rbLandConfigs: "مدیریت تنظیمات ربات لند",
    editConfig: "ویرایش تنظیمات",
    manageUsers: "مدیریت کاربران",
    categories: "دسته‌بندی‌ها",
    createCategory: "افزودن دسته‌بندی",
    editCategory: "ویرایش دسته‌بندی",
    content: "محتوا",
    createContent: "درج محتوا",
    editContent: "ویرایش محتوا",
    addUserGuide: "افزودن راهنمای کاربر",
    editUserGuide: "ویرایش راهنمای کاربر",
    roles: "نقش‌ها",
    editRole: "ویرایش نقش",
    createRole: "افزودن نقش",
    permissionTitle: "دسترسی‌ها", // For cruds.permission.title
    paymentGateways: "درگاه‌های پرداخت",
    editPaymentGateway: "ویرایش درگاه‌های پرداخت",
    campaigns: "کمپین‌ها",
    createCampaign: "ایجاد کمپین",
    editCampaign: "ویرایش اطلاعات کمپین",
    adminCustomers: "مشتریان",
    createCustomer: "ایجاد مشتریان",
    editCustomerInfo: "ویرایش اطلاعات مشتری",
    referrerCustomers: "مشتریان معرف",
    customerHistory: "تاریخچه‌ی مشتری",
    userProfile: "پروفایل کاربری",
    editProfile: "ویرایش پروفایل",
    inviteFriends: "دعوت از دوستان",
    personalInfo: "اطلاعات شخصی",
    editPersonalInfo: "ویرایش اطلاعات",
    changePassword: "تغییر رمز عبور",
    newWallet: "کیف پول جدید",
  },
  profileView: {
    email: "ایمیل",
    balance: "اعتبار",
    personType: "نوع شخص",
    currency: "ریال",
    unknown: "----",
  },
  panelInfoProfile: {
    panelTitle: "شما پنل {title} که {days} روزه است را دارید.",
    buyOrRenew: "برای خرید یا تمدید پنل خود روی دکمه زیر کلیک کنید.",
    buyPanel: "خرید پنل",
    percentage: "%",
  },
  profileSetting: {
    cardTitle: "تنظیمات پروفایل",
    changePasswordTitle: "تغییر رمز ورود",
    changePasswordSubtitle: "رمز ورود به حساب کاربری خود را تغییر دهید.",
    alertMessage:
      "اگر تا به امروز رمز عبور خود را وارد نکرده‌اید، تیک ثبت رمز ورود را فعال نمایید.",
    currentPasswordLabel: "رمز ورود فعلی",
    setPasswordLabel: "ثبت رمز ورود",
    addPassword: "افزودن رمز ورود",
    newPasswordLabel: "رمز ورود جدید",
    repeatPasswordLabel: "تکرار رمز ورود",
    saveChanges: "ثبت تغییرات",
    currentPasswordPlaceholder: "رمز ورود فعلی",
    newPasswordPlaceholder: "رمز ورود جدید",
    repeatPasswordPlaceholder: "تکرار رمز ورود",
  },
  profileOrders: {
    cardTitle: "سفارشات",
    openOrders: "سفارش‌های باز ({count})",
    closedOrders: "سفارش‌های بسته شده ({count})",
    noOrders: "تا حالا سفارشی از ما نداشتی",
  },
  personalInformation: {
    cardTitle: "اطلاعات حساب شخصی",
    cardSubtitle: "اطلاعات شخصی خود را به روز کنید.",
    cancel: "انصراف",
    update: "به روزرسانی",
    yourInfo: "اطلاعات شما",
    profilePicture: "تصویر پروفایل",
    allowedFileTypes: "انواع فایل‌های مجاز: png، jpg، jpeg.",
    pictureSize: "عکس پروفایل باید در اندازه‌های (مثال: ۴۸۰ × ۴۸۰) یکسان باشد.",
    name: "نام",
    lastName: "نام خانوادگی",
    username: "نام کاربری",
    receiveSMS: "دریافت پیامک",
    smsCostNote:
      "با فعال کردن این گزینه هزینه ارسال پیامک‌ها از حساب شما کسر خواهد شد.",
    phoneNumber: "شماره همراه",
    phonePlaceholder: "شماره همراه",
    email: "ایمیل",
    emailPlaceholder: "ایمیل",
    emailPrivacy: "ما هرگز ایمیل شما را با دیگران به اشتراک نمی‌گذاریم.",
    successMessage: "پروفایل شما با موفقیت بروزرسانی شد.",
  },
  userInfoForm: {
    companyName: "نام شرکت/فروشگاه",
    registrationNumber: "شماره ثبت",
    economicCode: "کد اقتصادی",
    organizationIdentity: "شناسنامه ملی سازمانی",
    companyType: "نوع شرکت",
    activity: "حوزه فعالیت",
    registrationAd: "تصویر آگهی ثبت شرکت",
    lastPublishedAd: "تصویر آخرین آگهی رسمی منتشر شده",
    statute: "تصویر اساسنامه شرکت",
    argentLetterPic: "تصویر نامه معرفی نماینده شرکت",
    phone: "شماره همراه",
    telephone: "شماره ثابت",
    fatherName: "نام پدر",
    nationalCode: "کد ملی",
    id: "شماره شناسنامه",
    birthday: "تاریخ تولد",
    placeBirthday: "محل تولد",
    postalCode: "کد پستی",
    email: "ایمیل",
    introduction: "نحوه آشنایی",
    nationalCodePic: "عکس کارت ملی",
    plaque: "پلاک",
    address: "آدرس کامل",
    companyTypes: {
      governmental: "دولتی",
      private: "خصوصی",
      common_stock: "سهامی عام",
      special_stock: "سهامی خاص",
    },
    rules: {
      companyName: "فیلد نام شرکت یا فروشگاه اجباری می باشد.",
      registration_number: "فیلد شماره ثبت اجباری می باشد.",
      economic_code: "فیلد کد اقتصادی اجباری می باشد.",
      organization_identity: "فیلد شناسنامه ملی سازمانی اجباری می باشد.",
      registration_ad: "فیلد تصویر آگهی ثبت شده اجباری می باشد.",
      last_published_ad: "فیلد تصویر آخرین آگهی رسمی منتشر شده اجباری می باشد.",
      telephone: "فیلد شماره ثابت اجباری می باشد.",
      fatherName: "فیلد نام پدر اجباری می باشد.",
      nationalCode: "فیلد کد ملی اجباری می باشد.",
      id: "فیلد شماره شناسنامه اجباری می باشد.",
      birthday: "فیلد تاریخ تولد اجباری می باشد.",
      placeBirthday: "فیلد محل تولد اجباری می باشد.",
      postalCode: "فیلد کد پستی اجباری می باشد.",
      nationalCodePic: "فیلد عکس کارت ملی اجباری می باشد.",
      address: "فیلد آدرس اجباری می باشد.",
      plaque: "فیلد پلاک اجباری می باشد.",
    },
  },
  createUserForm: {
    name: "نام",
    lastName: "نام خانوادگی",
    nid: "کد ملی",
    phone: "شماره همراه",
    create: "ایجاد",
    errors: {
      nameRequired: "نام وارد نشده است!",
      lastNameRequired: "نام خانوادگی وارد نشده است!",
      nidRequired: "کدملی وارد نشده است!",
      phoneRequired: "تلفن همراه وارد نشده است!",
    },
  },
  lastView: {
    cardTitle: "آخرین بازدیدهای شما",
    cardSubtitle: "آخرین بازدیدهای شما از صفحات ما",
    tableHeaders: {
      page: "صفحه",
      address: "آدرس",
      enterDate: "تاریخ ورود به صفحه",
      leaveDate: "تاریخ ترک صفحه",
      timeSpent: "زمان صرف شده در این صفحه",
    },
    viewAll: "مشاهده همه",
    timeUnit: "دقیقه",
    pages: {
      home: "خانه",
      panels: "پنل‌ها",
      profile: "تکمیل پروفایل",
    },
  },
walletWidget: {
  title: "تراکنش‌های اخیر",
  balanceLabel: "موجودی شما:",
  viewTransactions: "مشاهده تراکنش‌ها",
  transactionTypes: {
    withdraw: "برداشت وجه",
    deposit: "واریز وجه",
    charge: "شارژ کیف پول",
    refund: "بازگشت وجه",
    default: "تراکنش",
    adminCharge: "شارژ/کسر توسط مدیر",
    agency: "پورسانت نمایندگی",
  },
},
  panelWidget: {
    title: "شما پنل {title} که {days} روزه است را دارید.",
    renewPrompt: "برای خرید یا تمدید پنل خود روی دکمه زیر کلیک کنید.",
    buyPanel: "خرید پنل",
    percentage: "{value}%",
    infinity: "∞",
    days: "{count} روز",
  },
  component: {
    title: "کاربران دعوت شده توسط شما",
    columns: {
      row: "ردیف",
      name: "نام",
      family: "نام خانوادگی",
      username: "نام کاربری",
      phone: "شماره موبایل",
      created_at: "تاریخ عضویت",
      actions: "عملیات",
    },
    unknown: "نامعلوم",
    error: "خطا",
    breadcrumb: "کاربران دعوت شده",
  },
  table: {
    itemsPerPage: "تعداد ردیف‌ها در صفحه",
    pageText: "نمایش {0} تا {1} از {2} ورودی",
    prevText: "قبلی",
    nextText: "بعدی",
    noDataText: "داده‌ای موجود نیست",
    search: "جستجو",
  },
  UserHistory: {
    title: "تاریخچه کاربران",
    add_history: "ثبت تاریخچه جدید",
    send_message: "ارسال پیام",
    close: "بستن",
    save: "ذخیره",
    cancel: "انصراف",
    new_history_dialog_title: "ثبت تاریخچه جدید",
    send_message_dialog_title: "ارسال پیام",
    negotiations: "مذاکرات انجام شده",
    follow_up: "موارد پیگیری در تماس بعدی",
    success_history: "تاریخچه با موفقیت ثبت شد.",
    success_message: "پیام با موفقیت ارسال شد.",
    columns: {
      id: "شناسه",
      title: "عنوان",
      status: "مرحله",
      current_time_date: "تاریخ آخرین تماس",
      current_time_hour: "ساعت آخرین تماس",
      next_time_date: "تاریخ تماس بعدی",
      next_time_hour: "ساعت تماس بعدی",
      user_id: "پشتیبان",
      actions: "عملیات",
    },
    table: {
      itemsPerPage: "تعداد ردیف‌ها در صفحه",
      pageText: "نمایش {0} تا {1} از {2} ورودی",
      prevText: "قبلی",
      nextText: "بعدی",
      noDataText: "داده‌ای موجود نیست",
      search: "جستجو",
    },
    form: {
      title: "عنوان",
      status: "مرحله",
      current_time: "تاریخ آخرین تماس",
      description: "توضیحات",
      next_time: "تاریخ تماس بعدی",
      pursue_text: "پیگیری تماس بعدی",
      category: "انتخاب دسته‌بندی",
      message_title: "عنوان پیام",
    },
  },
  newUserTransactions: {
    userWallet: "کیف پول کاربر",
    transactionList: "لیست تراکنش‌ها",
    userTransactions: "تراکنش‌های کاربر",
    terminal: "ترمینال",
    liveSms: "پیامک زنده",
    realEstateNews: "تازه‌های دیوار",
    rial: "ریال",
    row: "ردیف",
    uniqueId: "شناسه",
    amount: "مبلغ",
    time: "ساعت",
    createdAt: "تاریخ",
    description: "توضیحات تکمیلی",
    type: "نوع تراکنش",
    product_description: "توضیح",
    serviceId: "نام سرویس",
    balanceAfter: "مانده موجودی",
    perPage: "تعداد",
    search: "جستجو",
    balance: "موجودی",
    transactionListTooltip: "لیست تراکنش‌ها",
    panelLogin: "ورود به پنل",
    history: "تاریخچه",
    error: {
      terminalWallet: "خطا در دریافت کیف پول ترمینال",
    },
    row: "ردیف",
    uniqueId: "شناسه",
    amount: "مبلغ",
    time: "ساعت",
    createdAt: "تاریخ",
    description: "توضیحات تکمیلی",
    type: "نوع تراکنش",
    product_description: "توضیح",
    serviceId: "نام سرویس",
    balanceAfter: "مانده موجودی",
    search: "جستجو",
    perPage: "تعداد",
    transactionType: "نوع تراکنش",
    service: "سرویس",
    dateFrom: "تاریخ از",
    dateTo: "تا تاریخ",
    oldWallet: "کیف پول قدیمی",
    depositReceipt: "رسید واریز",
    showReceipt: "نمایش رسید",
    transactionTypes: {
      online: "آنلاین",
      admin: "توسط مدیر",
      refund: "تراکنش اصلاحی",
      agency: "عاملیت",
      withdraw: "برداشت",
      deposit: "واریز",
      adminCharge: "تراکنش توسط ادمین",
      charge: "شارژ کیف پول",
      refund: "بازگشت وجه",
    },
    error: {
      imageLoad: "خطا در بارگذاری تصویر!",
    },
  },
  buyPanel: {
    alert: {
      choosePanel: "لطفا در انتخاب نوع پنل دقت فرمایید!",
    },
    dialog: {
      title: "خرید پنل",
      confirmPurchase: "آیا از خرید پنل {title} اطمینان دارید؟",
      discountCodeLabel: "کد تخفیف",
      discountCodePlaceholder: "کد تخفیف خود را وارد کنید",
      applyDiscount: "ثبت کد",
      purchase: "خرید",
      iHaveDiscount: "کد تخفیف دارم",
    },
    toast: {
      discountApplied: "کد تخفیف شما با موفقیت اعمال شد!",
      purchaseSuccess: "بسته با موفقیت خرید شد",
      error: "خطایی رخ داده است: {message}",
      unauthorized: "لطفا ابتدا وارد شوید",
      validationError: "خطای اعتبارسنجی: {message}",
    },
    currency: "ریال",
  },
  panelCard: {
    rial: "ریال",
    days: "روزه",
    buyPanel: "خرید پنل",
  },
  cons: {
    title: "انتخاب ایموجی",
  },
  cons1: {
    title: "متن پیشفرض",
  },
  MENUS: {
    AD_TERMINAL_SYSTEM: "سامانه بزرگ ترمینال تبلیغات",
  },
};
